export class PhinestError extends Error {
    code;
    hint;
    details;
    constructor(code, message, opts = {}) {
        super(message, opts.cause ? { cause: opts.cause } : undefined);
        this.name = 'PhinestError';
        this.code = code;
        this.hint = opts.hint;
        this.details = opts.details;
    }
    toJSON() {
        return { error: this.code, message: this.message, hint: this.hint, details: this.details };
    }
}
export const notFound = (what, id, hint) => new PhinestError('not_found', id ? `${what} ${id} was not found in this workspace.` : `${what} was not found.`, {
    hint: hint ?? `Search for it first (e.g. search_customers) and use the id from the result.`,
});
export const validation = (message, hint, details) => new PhinestError('validation', message, { hint, details });
export const invalidState = (message, hint) => new PhinestError('invalid_state', message, { hint });
export const permissionDenied = (what) => new PhinestError('permission_denied', `You do not have permission to ${what}.`, {
    hint: 'Ask a workspace admin to change your role, or use a read-only tool instead.',
});
/** Translate a Postgres error into a PhinestError with a readable message. */
export function fromPgError(err) {
    if (err instanceof PhinestError)
        return err;
    const e = (err ?? {});
    const msg = e.message ?? String(err);
    switch (e.code) {
        case '23505':
            return new PhinestError('conflict', `A record with the same unique value already exists. ${e.detail ?? ''}`.trim(), {
                hint: 'Search for the existing record and update it instead of creating a duplicate.',
                details: { constraint: e.constraint_name },
            });
        case '23503':
            return new PhinestError('validation', `A referenced record does not exist or is still in use. ${e.detail ?? ''}`.trim(), {
                hint: 'Check the ids you passed; they must belong to this workspace.',
                details: { constraint: e.constraint_name },
            });
        case '23502':
            return new PhinestError('validation', `Missing required value${e.column_name ? ` for "${e.column_name}"` : ''}. ${msg}`, {
                hint: e.hint,
            });
        case '23514':
            return new PhinestError('validation', `A value is outside the allowed set. ${msg}`, {
                hint: e.hint ?? `Constraint: ${e.constraint_name ?? 'unknown'}. Check status/enum values and ranges.`,
            });
        case '22023':
        case '22P02':
        case '22007':
        case '22008':
            return new PhinestError('validation', msg, { hint: e.hint });
        case '42501':
            return new PhinestError('permission_denied', 'This action is not permitted for your role (row-level security).', {
                hint: 'Ask a workspace admin for access, or use a read-only tool.',
            });
        case 'P0001':
            return new PhinestError('invalid_state', msg, { hint: e.hint });
        default:
            return new PhinestError('internal', msg, { hint: e.hint, details: e.code ? { pg_code: e.code } : undefined, cause: err });
    }
}
//# sourceMappingURL=errors.js.map